const GLOBAL_QUERY_LOADING_DELAY_MS = 150

export function hasActiveQueries(fetchingCount: number): boolean {
  return fetchingCount > 0
}

export function scheduleLoadingIndicator(
  onVisible: (visible: true) => void,
  delayMs = GLOBAL_QUERY_LOADING_DELAY_MS,
): () => void {
  const timer = globalThis.setTimeout(() => onVisible(true), delayMs)
  return () => globalThis.clearTimeout(timer)
}
